"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userLogin = exports.userInfo = exports.updateUser = exports.upDataUserInfo = exports.unLock = exports.stopUser = exports.resetPsd = exports.registerRole = exports.registerLsit = exports.registerApply = exports.provAdmin = exports.getregInfo = exports.getSchoolLIST = exports.getBSID = exports.editRegInfo = exports.delregInfo = exports.deleteUser = exports.auditRegister = exports.addUser = exports.activeUser = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
/**
 * 描述 用户登录
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data 
 * @returns {any}
 */
var userLogin = exports.userLogin = function userLogin(data) {
  return _api.default.request({
    url: '',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取用户信息
 * @author kkdy
 * @date 2021-12-02
 * @param {any} data
 * @returns {any}
 */
var userInfo = exports.userInfo = function userInfo(data) {
  return _api.default.request({
    url: '',
    method: 'post',
    data: data
  });
};
/**
 * 描述 更新用户信息
 * @author kkdy
 * @date 2021-12-02
 * @param {any} data
 * @returns {any}
 */
var upDataUserInfo = exports.upDataUserInfo = function upDataUserInfo(data) {
  return _api.default.request({
    url: '/user/updateUserInfo',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除用户
 * @author kkdy
 * @date 2021-12-05
 * @param {any} data
 * @returns {any}
 */
var deleteUser = exports.deleteUser = function deleteUser(data) {
  return _api.default.request({
    url: '/user/deleteUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 禁用用户
 * @author kkdy
 * @date 2021-12-05
 * @param {any} data
 * @returns {any}
 */
var stopUser = exports.stopUser = function stopUser(data) {
  return _api.default.request({
    url: '/user/disableUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 取消禁用专家
 * @author kkdy
 * @date 2021-12-05
 * @param {any} data
 * @returns {any}
 */
var unLock = exports.unLock = function unLock(data) {
  return _api.default.request({
    url: '/user/enableUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 重置密码
 * @author kkdy
 * @date 2021-12-05
 * @param {any} data
 * @returns {any}
 */
var resetPsd = exports.resetPsd = function resetPsd(data) {
  return _api.default.request({
    url: '/user/resetPass',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增用户
 * @author kkdy
 * @date 2021-12-09
 * @param {any} data userType	业务类型 1：省 2：教育局 3：学校
 * @returns {any}
 */
var addUser = exports.addUser = function addUser(data) {
  return _api.default.request({
    url: '/user/saveUser',
    method: 'post',
    data: data
  });
};
/**
 * 修改用户信息
 */
var updateUser = exports.updateUser = function updateUser(data) {
  return _api.default.request({
    url: '/user/updateUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取省份管理员
 * @author kkdy
 * @date 2021-12-10
 * @param {any} data
 * @returns {any}
 */
var provAdmin = exports.provAdmin = function provAdmin(data) {
  return _api.default.request({
    url: '/province/getProvinceAdmins',
    method: 'post',
    data: data
  });
};
/**
 * 描述 取消禁用
 * @author kkdy
 * @date 2021-12-10
 * @param {any} data
 * @returns {any}
 */
var activeUser = exports.activeUser = function activeUser(data) {
  return _api.default.request({
    url: '/user/enableUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 注册
 * @author kkdy
 * @date 2022-03-18
 * @param {any} data
 * @returns {any}
 */
var registerApply = exports.registerApply = function registerApply(data) {
  return _api.default.request({
    url: '/user/enableUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 注册老师或学生
 * @author kkdy
 * @date 2022-03-20
 * @param {any} data
 * @returns {any}
 */
var registerRole = exports.registerRole = function registerRole(data) {
  return _api.default.request({
    url: '/user/registerUser',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据省份code获取对应BusinessId
 * @author kkdy
 * @date 2022-03-20
 * @param {any} data
 * @returns {any}
 */
var getBSID = exports.getBSID = function getBSID(data) {
  return _api.default.request({
    url: '/web/getBusinessIdByCode',
    method: 'post',
    data: data
  });
};
/**
 * 描述
 * @author kkdy
 * @date 2022-03-20
 * @param {any} data
 * @returns {any}
 */
var getSchoolLIST = exports.getSchoolLIST = function getSchoolLIST(data) {
  return _api.default.request({
    url: '/school/schoolListByCode',
    method: 'post',
    data: data
  });
};
/**
 * 描述 获取学校下注册的列表
 * @author kkdy
 * @date 2022-03-20
 * @param {any} data
 * @returns {any}
 */
var registerLsit = exports.registerLsit = function registerLsit(data, path) {
  return _api.default.request({
    url: '/user/registerUserList/' + path,
    method: 'post',
    data: data
  });
};
/**
 * 描述 审核注册
 * @author kkdy
 * @date 2022-03-20
 * @param {any} data
 * @param {any} path
 * @returns {any}
 */
var auditRegister = exports.auditRegister = function auditRegister(data, path) {
  return _api.default.request({
    url: '/user/auditRegisterUser/' + path,
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除 学生-老师注册
 * @author kkdy
 * @date 2022-03-23
 * @param {any} data
 * @param {any} path
 * @returns {any}
 */
var delregInfo = exports.delregInfo = function delregInfo(data, path) {
  return _api.default.request({
    url: '/user/deleteRegisterUserInfo',
    method: 'post',
    data: data
  });
};
/**
 * 描述 根据Id获取注册信息
 * @author kkdy
 * @date 2022-03-23
 * @param {any} data
 * @param {any} path
 * @returns {any}
 */
var getregInfo = exports.getregInfo = function getregInfo(data, path) {
  return _api.default.request({
    url: '/user/registerUserInfo',
    method: 'post',
    data: data
  });
};
/**
 * 描述 修改注册信息
 * @author kkdy
 * @date 2022-03-23
 * @param {any} data
 * @param {any} path
 * @returns {any}
 */
var editRegInfo = exports.editRegInfo = function editRegInfo(data, path) {
  return _api.default.request({
    url: '/user/updateRegisterUserInfo',
    method: 'post',
    data: data
  });
};